<main>
  <app-header [position]="common.header$ | async"></app-header>
  <router-outlet></router-outlet>
</main>
